export const requestSourceMap = {
  'import-lpn-requests': 'laadpaalnodig.nl'
}
